<template>
     <modal class="bindMemberModel" :isShow="isShow" @keyup.esc="hide">
        <div class="header">绑定电子会员<span class="close" @click="hide()">×</span></div>
        
        <div class="modal-body">
            <div class="filter-nav">
                <div class="nav-box">
                    <div class="nav-li selected">按会员卡号</div>
                </div>
            </div>
            <div class="flex-box">
                <div class="left-box">
                    <div class="readCard-box">
                        请扫码或输入会员码：
                        <div class="from-input" style="width:325px">
                            <input type="text" ref="input" class="key-focus" data-model='idCode' @focus="(e)=>e.target.select()"  v-model="idCode" @keyup.enter="onMemberInfo()" />
                            <i class="iconfont icon-sousuo" @click="onMemberInfo()"></i>
                        </div>
                        <button class="btn" @click="readCard()">读卡</button>
                    </div>
                    <div class="info-box">
                        <div class="tr-li">
                            <div class="flex-1">会员卡号：<span class="lable-text">{{meberInfo?.Card_No}}</span></div>
                            <div class="flex-1">会员等级：<span class="lable-text">{{meberInfo?.Bestech_Card_KindName}}</span></div>
                            <div class="flex-1">姓名：<span class="lable-text">{{meberInfo?.MemberName}}</span></div>
                        </div>
                        <div class="tr-li">
                            <div class="flex-1">
                                手&nbsp; 机 &nbsp;号:
                                <span class="lable-text" v-if="meberInfo">{{$global.phonePrivacy(meberInfo?.Mobile)}}</span>
                            </div>
                            <div class="flex-1">
                                性 &nbsp; &nbsp; &nbsp; 别：
                                <span class="lable-text" v-if="meberInfo?.Gender>-1">{{meberInfo?.Gender==0?'男':'女'}}</span>
                            </div>
                            <div class="flex-1">生日：<span class="lable-text">{{meberInfo?.Birthday}}</span></div>
                        </div>
                        <div class="tr-li">
                            <div class="flex-1">
                                余 &nbsp; &nbsp; &nbsp; 额:
                                <span class="lable-text number" v-if="meberInfo?.Card_Money>0" >{{Number(meberInfo.Card_Money)}}</span>
                                <span style="color: red;"  v-if="meberInfo?.Gift_Money>0" >（赠{{Number(meberInfo.Gift_Money)}}）</span>
                            </div>
                            <div class="flex-1">
                                可&nbsp; 用 &nbsp;券：
                                <span class="lable-text number">{{meberInfo?.Live_CouponsNum}}</span>
                                <span style="color: red;padding-left:5px;" v-if="meberInfo?.Live_CouponsNum">张</span>
                            </div>
                            <div class="flex-1">积分：
                                <span class="lable-text number"  v-if="meberInfo?.Card_PilePoint>0">{{Number(meberInfo.Card_PilePoint)}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="right-box">
                    <div class="keyboard">
                        <div class="key-li"><span data-value="7">7</span><span data-value="8">8</span><span
                                data-value="9">9</span></div>
                        <div class="key-li"><span data-value="4">4</span><span data-value="5">5</span><span
                                data-value="6">6</span></div>
                        <div class="key-li"><span data-value="1">1</span><span data-value="2">2</span><span
                                data-value="3">3</span></div>
                        <div class="key-li"><span data-value=".">.</span><span data-value="0">0</span><span
                                data-value="back"><i class="iconfont icon-zuojiantou"></i></span></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer-box">
            <button class="btn btn-cancel" @click="hide()">取消</button>
            <button class="btn btn-confirm" @click="confirm()">绑定</button>
        </div>
        <!--会员卡信息-->
        <modal-load :isShow="cardMemberShow">
            <card-member-Model :isShow="cardMemberShow" @closeModel="cardMemberShow=false" :data="cardMemberList" @confirm="selectCardInfo" ></card-member-Model>
        </modal-load>
    </modal>
</template>

<script>
import {initKeyBoard} from '/src/common' 
import cardMemberModel from '../../../model/cardMemberModel/cardMemberModel.vue'
export default {
    components:{
        cardMemberModel
    },
    emits:["close","confirm"],
    props:{
        isShow:{
            type:Boolean
        },
        /**爱护网卡号 */
        aiHuCardNo:{
            type:String
        }
    },
    data(){
        return {
            //卡号
            idCode:"",
            //会员信息
            meberInfo:null,
            //多选卡 选择弹层
            cardMemberShow:false,
            //多会员信息列表
            cardMemberList:null
        }
    },
    mounted(){
        initKeyBoard.call(this,this.$el);
        this.$nextTick(()=>{
            this.$refs.input?.focus();
        })
    },
    methods:{
         /**数据初始化 */
        initializaTion(){
            this.meberInfo=null;
            this.payCode="";
        },
        hide(){
            this.$emit("close");
        },
        /**读卡 */
        readCard(){
            this.$webBrowser.redCardM1().then((d)=>{
                if(d){
                    if(d.state==0){
                        this.card_AutoID=d.data.cardID;
                        this.idCode=d.data.cardNo;
                        this.cardSNR=d.data.snr
                        this.onMemberInfo()
                    }else{
                        this.$message.error('卡信息读取失败：'+d.message);
                    }
                }
            })
        },
        /**请求会员信息 */
        onMemberInfo(){
            if(!this.idCode && !this.cardSNR){
                this.$message.warning('查询码不能为空');
                return
            }
            this.idCode =this.idCode.replace(/[;,；,=,＝,?,？]/g,"");
            this.$refs.input?.select();
            
            this.userInfo=this.$auth.getUserInfo(); //获取用户id
            let param={
                User_ID:this.userInfo?.User_ID,  //用户id
                DynamicNo:this.idCode,
                Card_AutoID:this.card_AutoID,
                Card_SN:this.cardSNR,
                Member_Type:2,//
            };
            this.cardSNR='';
            this.card_AutoID='';
            const loading = this.$loading({
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.1)",
            });
            this.$httpAES.post("Bestech.CloudPos.GetMemberInfo",param).then((data)=>{
                loading.close();
                if(data.ResponseHeader.ResultCode!=0){
                    this.$message.error(data.ResponseHeader.ResultDesc);
                    this.idCode=''
                }else{
                    if(data.ResponseBody.length>1){
                        this.cardMemberList = data.ResponseBody;
                        this.cardMemberShow=true;
                    }else{
                        this.meberInfo=data.ResponseBody[0];
                    }
                }
            }).catch((e)=>{
                loading.close();
                this.$alert(e.message, "提示", {confirmButtonText: "确定"});
            })
        },
        /**会员卡选择返回 */
        selectCardInfo(data){
            this.meberInfo=data;
            this.idCode = data.Card_No;
            this.cardMemberShow = false;
        },
        /**确定绑定 */
        confirm(){
            if(!this.aiHuCardNo){
                this.$message.warning('爱护网卡号不能为空!');
                return
            }
            if(!this.meberInfo?.Card_No){
                this.$refs.input?.focus();
                this.$message.warning('会员卡号不能为空!请先去读卡');
                return
            }
            let param={
                User_ID:this.userInfo?.User_ID, //登陆用户ID
                AiHuWangCardNo: this.aiHuCardNo,//爱护网卡号
                BestCRMCardNo:this.meberInfo.Card_No,//正品CRM卡号
            }
            /**绑定卡号 */
            const loading = this.$loading({
                text: "卡号绑定提交中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.1)",
            });
            this.$httpAES.post("Bestech.CloudPos.AiHuWangBindCRM",param).then((data)=>{
                loading.close();
                if(data.ResponseHeader.ResultCode!=0){
                    this.$message.error(data.ResponseHeader.ResultDesc);
                }else{
                    this.$message.success("卡号绑定成功");
                    this.$emit('confirm',this.meberInfo);
                }
            }).catch((e)=>{
                loading.close();
                this.$alert(e.message, "提示", {confirmButtonText: "确定"});
            })
        }
    }
}
</script>

<style lang="sass">
@import "./bindMemberModel.scss";
</style>